export function injectDisableAnimationsStyle(shouldDisable?: boolean) {
    const styleId = "disable-animations-style"

    const existingTag = document.getElementById(styleId)
    if (existingTag) {
        existingTag.remove()
    }

    if (shouldDisable) {
        const style = document.createElement("style")
        style.id = styleId
        style.innerHTML = `
      * {
        animation: none !important;
        transition: none !important;
      }
    `
        document.head.appendChild(style)
    }
}
